import React, {Component} from "react";
import "./Footer.css";

//import PageSection from "PageSection/PageSection";
import Icon from "Icon/Icon";
import Hyperlink from "Hyperlink/Hyperlink";

export default class Footer extends Component
{
	render()
	{
		return (
			<footer className="footer">
				{/*<div className="name">
					Andrew Guterman
				</div>*/}

				<div className="social">
					<Hyperlink href="https://github.com/andrew4699/" className="item" newTab>
						<Icon title="GitHub">github</Icon>
					</Hyperlink>

					<Hyperlink href="https://www.linkedin.com/in/andrew-guterman/" className="item" newTab>
						<Icon title="LinkedIn">linkedin</Icon>
					</Hyperlink>
				</div>
			</footer>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js